import Vue from 'vue'
import App from './App.vue'
import router from "./router";
import store from "./store";

// element库注册
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css'; 
Vue.use(ElementUI);


// Json编辑器
import CodeEditor from 'bin-code-editor';
import 'bin-code-editor/lib/styles/index.css';
Vue.use(CodeEditor);

// 引入md5
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;

// 注册全局组件
import components from './components'   
Vue.use(components);

// 全局样式
import './assets/stylesheets/index.less'

// echarts
import * as echarts from "echarts";
Vue.prototype.$echarts = echarts;

// window.addEventListener('message', function (event) {
//   if(event.origin != 'http://192.168.201.129:3000') return 
//   console.log('接受',event)
//   localStorage.setItem('ms_username', event.data)
//   // document.cookie = "token=" + event.data;
//   // ElMessage.success("登录成功"); 
//   // router.push("/");
//   // this.window.open("http://192.168.201.129:3000/#/dashboard")
// }, false);

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
